import {CircularProgress} from "@mui/material";

export default function LoadingOverlay() {
    return (
        <div style={{
            backgroundColor: "rgba(0,0,0,.5)",
            position: "fixed",
            left: 0, top: 0, right: 0, bottom: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        }}>
            <CircularProgress style={{color: '#d09705'}} />
        </div>
    );
};
